module.exports = __webpack_public_path__ + "resources/img/banner-6.d4888df7.jpg";